const { EpisodeContext } = require('contexts/EpisodeContext');
const { useContext } = require('react');

const useEpisode = () => useContext(EpisodeContext);

export default useEpisode;
